import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import BankFailure from '../BankFailure/BankFailure';
import TechnicalBankFailure from '../BankFailure/TechnicalBankFailure';
import TimeOutFailure from '../BankFailure/TimeOutFailure';
import BankLanding from '../BankLanding/BankLanding';
import BankSelection from '../BankSelection/BankSelection';
import BankSuccess from '../BankSuccess/BankSuccess';
import config from '../../../config/config';
import Everify from '../Everify/Everify';
import LinkBank from '../LinkBank/LinkBank';
import ManualEntry from '../ManualEntry/ManualEntry';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import { BankStatusFailure } from '../BankStatusFailure/BankStatusFailure';
import { Verified } from '../BankStatusFailure/StatusMessages';
import PartialBankFailure from '../BankFailure/PartialBankFailure';
import {
  getHasInheritedIRAAgreementsOnly,
  getHasStopFeatureOnAnyAgreement,
  getIs529CustodianOnly,
  getRPSOrTRAConly,
  getMD529Decom,
} from '../../../redux/modules/productTypes/productType.selectors';
import {
  hasEligibilitySucceed,
  hasIneligibleAgreements,
} from '../../../redux/modules/eligibleAgreements/eligibleAgreements.selectors';
import {
  ADD_BANK_MODAL,
  closeModal,
} from '../../../redux/modules/modals/modals.module';
import {
  ANY_STOP_TRANSFER,
  CUSTODIAN_ONLY,
  MD529_DECOMMISSION,
  NON_ELIGIBLE_AGREEMENTS,
  TRAC_OR_RPS_ONLY,
} from '../../../settings/settings';
import { getHasErrorType } from '../../../redux/modules/linkedBanks/linkBank.selectors';

export const PATH_LINK = 'LINK';
export const PATH_MANUAL = 'MANUAL';
export const STEP_BANK_FAILURE = 'BANK_FAILURE';
export const STEP_BANK_STATUS_FAILURE = 'BANK_STATUS_FAILURE';
export const TECHNICAL_BANK_FAILURE = 'TECHNICAL_BANK_FAILURE';
export const EVY_TIME_OUT = 'EVY_TIME_OUT';
export const STEP_BANK_SELECTION = 'BANK_SELECTION';
export const STEP_BANK_SUCCESS = 'BANK_SUCCESS';
export const STEP_EVERIFY = 'EVERIFY';
export const STEP_MANUAL = 'MANUAL_ENTRY';
export const STEP_LANDING = 'LANDING';
export const STEP_LINK_BANK = 'LINK_BANK';
export const STEP_BANK_ADDED = 'BANK_ADDED';
export const STEP_BANK_ADDED_PARTIALLY = 'BANK_ADDED_PARTIALLY';

class AddBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'INIT',
      currentStep: window.location.href.includes('?oauth_state_id=')
        ? STEP_LINK_BANK
        : STEP_LANDING,
      entryPoint: null,
      path: null,
    };
    this.handleHide = this.handleHide.bind(this);
    this.redirectUser = this.redirectUser.bind(this);
  }

  componentDidMount() {
    this.loadExistingBanks();
    if (this.props.isSalesforceRep) {
      this.setBankProgress(STEP_MANUAL);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { getHasErrorType, dispatch, isSalesforceRep } = this.props;
    if (
      prevState.currentStep !== STEP_MANUAL &&
      this.state.currentStep === STEP_MANUAL
    ) {
      const {
        actions: { resetEverify },
      } = this.props;
      resetEverify();
    }

    if (
      !prevProps.linkedBanks.banksLoading &&
      this.props.linkedBanks.banksLoading
    ) {
      this.setBankProgress(STEP_BANK_SELECTION);
    }

    const hasError = getHasErrorType;
    if (
      hasError &&
      this.state.currentStep !== STEP_LANDING &&
      !isSalesforceRep
    ) {
      dispatch(closeModal(ADD_BANK_MODAL));
    }
  }

  componentWillUnmount() {
    this.handleHide();
  }

  loadExistingBanks() {
    const {
      actions: { getExistingBanks },
      existingBanks: { fetchingAccounts, isLoaded },
    } = this.props;

    if (!isLoaded && !fetchingAccounts) {
      getExistingBanks();
    }
  }

  handleHide = () => {
    const {
      actions: { resetEverify },
      dispatchPageLoad,
      handleExit,
      standalone,
      getHasErrorType,
    } = this.props;

    resetEverify();
    if (!standalone) {
      dispatchPageLoad('Step 1');
      return;
    }
    handleExit();
    const hasError = getHasErrorType;
    if (!hasError || this.state.currentStep === STEP_LANDING) {
      this.redirectUser();
    }
  };

  redirectUser() {
    window.location =
      window.document.referrer.includes('troweprice') &&
      !window.document.referrer.includes('login')
        ? window.document.referrer
        : `${config.url}/usis/my-accounts/profile/linked-bank-accounts`;
  }

  markComplete = (value) => {
    if (value) {
      this.setState({ status: 'COMPLETE' });
    }
  };

  setBankProgress = (step) => {
    this.setState({ currentStep: step });
  };

  setUserPath = (path) => {
    // will be either LINK or MANUAL
    this.setState({ path });
  };

  getError = () => {
    const {
      hasInheritedIRAAgreementsOnly,
      hasStopFeatureOnAnyAgreement,
      ineligibleAgreements,
      is529CustodianOnly,
      didIneligibleAgreementsSucceed,
      RPSOrTRAConly,
      isMD529Decom,
    } = this.props;
    const hasError =
      hasInheritedIRAAgreementsOnly ||
      hasStopFeatureOnAnyAgreement ||
      (ineligibleAgreements && didIneligibleAgreementsSucceed) ||
      is529CustodianOnly ||
      RPSOrTRAConly ||
      isMD529Decom;
    if (
      (ineligibleAgreements && didIneligibleAgreementsSucceed) ||
      hasInheritedIRAAgreementsOnly
    ) {
      return { hasError, errorType: NON_ELIGIBLE_AGREEMENTS };
    } else if (hasStopFeatureOnAnyAgreement) {
      return { hasError, errorType: ANY_STOP_TRANSFER };
    } else if (is529CustodianOnly) {
      return { hasError, errorType: CUSTODIAN_ONLY };
    } else if (RPSOrTRAConly) {
      return { hasError, errorType: TRAC_OR_RPS_ONLY };
    } else if (isMD529Decom) {
      return { hasError, errorType: MD529_DECOMMISSION };
    }

    return { hasError, errorType: '' };
  };

  render() {
    const {
      isSalesforceRep,
      actions,
      customerWebViewEnabled,
      dispatch,
      dispatchPageLoad,
      eVerification,
      existingBanks,
      lastEverifyFailure,
      linkedBanks,
      onCloseClick,
      personalInformation,
      standalone,
      isLoading,
      getHasErrorType,
    } = this.props;
    const hasError = getHasErrorType;
    if (
      hasError &&
      this.state.currentStep !== STEP_LANDING &&
      !isSalesforceRep
    ) {
      dispatch(closeModal(ADD_BANK_MODAL));
    }
    const { currentStep, path, status } = this.state;
    if (standalone && (status === 'COMPLETE' || status === 'LEAVING')) {
      return (
        <FullPageLoader
          isVisible
          hasError={false}
          messages={['Loading Account Details', 'One Moment Please']}
        />
      );
    }

    if (isSalesforceRep && this.getError().hasError) {
      return (
        <FullPageLoader
          hasError={this.getError().hasError}
          errorType={this.getError().errorType}
        />
      );
    }
    return (isLoading || this.getError().hasError) && isSalesforceRep ? null : (
      <div>
        <Switch test={currentStep}>
          <Case value={STEP_LANDING}>
            <BankLanding
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              dispatchPageLoad={dispatchPageLoad}
              eVerification={eVerification}
              lastEverifyFailure={lastEverifyFailure}
              linkedBanks={linkedBanks}
              path={path}
              setUserPath={this.setUserPath}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_LINK_BANK}>
            <LinkBank
              dispatchPageLoad={dispatchPageLoad}
              handleClose={onCloseClick}
              currentStep={currentStep}
              eVerification={eVerification}
              setUserPath={this.setUserPath}
              actions={actions}
              linkedBanks={linkedBanks}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_BANK_SELECTION}>
            <BankSelection
              dispatchPageLoad={dispatchPageLoad}
              personalInformation={personalInformation}
              actions={actions}
              handleClose={onCloseClick}
              path={path}
              linkedBanks={linkedBanks}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_BANK_SUCCESS}>
            <BankSuccess
              dispatchPageLoad={dispatchPageLoad}
              dispatch={dispatch}
              actions={actions}
              existingBanks={existingBanks}
              path={path}
              linkedBanks={linkedBanks}
              markComplete={this.markComplete}
              setBankProgress={this.setBankProgress}
              handleClose={onCloseClick}
              isSalesforceRep={isSalesforceRep}
            />
          </Case>
          <Case value={STEP_BANK_FAILURE}>
            <BankFailure
              isSalesforceRep={isSalesforceRep}
              actions={actions}
              dispatchPageLoad={dispatchPageLoad}
              eVerification={eVerification}
              lastEverifyFailure={lastEverifyFailure}
              linkedBanks={linkedBanks}
              path={path}
              handleClose={onCloseClick}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_BANK_ADDED_PARTIALLY}>
            <PartialBankFailure
              isSalesforceRep={isSalesforceRep}
              dispatchPageLoad={dispatchPageLoad}
            />
          </Case>
          <Case value={STEP_BANK_STATUS_FAILURE}>
            <BankStatusFailure
              actions={actions}
              dispatchPageLoad={dispatchPageLoad}
              eVerification={eVerification}
              path={path}
              handleClose={onCloseClick}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={TECHNICAL_BANK_FAILURE}>
            <TechnicalBankFailure
              isSalesforceRep={isSalesforceRep}
              dispatchPageLoad={dispatchPageLoad}
              handleClose={onCloseClick}
              setBankProgress={this.setBankProgress}
              path={path}
            />
          </Case>
          <Case value={EVY_TIME_OUT}>
            <TimeOutFailure
              dispatchPageLoad={dispatchPageLoad}
              handleClose={onCloseClick}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_MANUAL}>
            <ManualEntry
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              dispatchPageLoad={dispatchPageLoad}
              personalInformation={personalInformation}
              setUserPath={this.setUserPath}
              actions={actions}
              existingBanks={existingBanks}
              eVerification={eVerification}
              setBankProgress={this.setBankProgress}
              handleClose={onCloseClick}
            />
          </Case>
          <Case value={STEP_EVERIFY}>
            <Everify
              customerWebViewEnabled={customerWebViewEnabled}
              isSalesforceRep={isSalesforceRep}
              dispatchPageLoad={dispatchPageLoad}
              dispatch={dispatch}
              actions={actions}
              eVerification={eVerification}
              existingBanks={existingBanks}
              handleClose={onCloseClick}
              path={path}
              setBankProgress={this.setBankProgress}
            />
          </Case>
          <Case value={STEP_BANK_ADDED}>
            <Verified
              handleClose={onCloseClick}
              setBankProgress={this.setBankProgress}
              path={path}
            />
          </Case>
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hasInheritedIRAAgreementsOnly: getHasInheritedIRAAgreementsOnly(state),
    hasStopFeatureOnAnyAgreement: getHasStopFeatureOnAnyAgreement(state),
    is529CustodianOnly: getIs529CustodianOnly(state),
    RPSOrTRAConly: getRPSOrTRAConly(state),
    getHasErrorType: getHasErrorType(state),
    ineligibleAgreements: hasIneligibleAgreements(state),
    isLoading: state.userProductTypes.isLoading,
    didIneligibleAgreementsSucceed: hasEligibilitySucceed(state),
    isMD529Decom: getMD529Decom(state),
  };
};

export default compose(connect(mapStateToProps))(AddBank);
